import { graphql } from 'gatsby'
import React, { useEffect, useState } from 'react'
import ColumnBackAndForth from '../../../components/atoms/columnBackAndForth'
import SEO from '../../../components/atoms/seo'
import { ITopicPath } from '../../../components/atoms/topicPath'
import ColumnDetailInner0070 from '../../../components/molecules/columnDetailInner0070'
import ColumnDetailsBody from '../../../components/organisms/columnDetailsBody'
import ColumnLayout from '../../../components/organisms/columnLayout'
import Conclusion001 from '../../../components/molecules/Conclusion001'
import Conclusion002 from '../../../components/molecules/Conclusion002'
import Conclusion003 from '../../../components/molecules/Conclusion003'
import Conclusion004 from '../../../components/molecules/Conclusion004'
import Conclusion005 from '../../../components/molecules/Conclusion005'
import Conclusion006 from '../../../components/molecules/Conclusion006'
import Conclusion007 from '../../../components/molecules/Conclusion007'
import Conclusion008 from '../../../components/molecules/Conclusion008'
import Conclusion009 from '../../../components/molecules/Conclusion009'
import CarouselBanner from '../../../components/molecules/carouselBanner'
import PopupBanner from '../../../components/molecules/popupBanner'
import ColumnAuthor004 from '../../../components/molecules/columnAuthor004'
import UsefulFunctionLayout003 from '../../../components/molecules/usefulFunctionLayout003'
import useRouteParam from '../../../hooks/useRouteParam'

/**
 * コラム記事詳細画面
 * @constructor
 */
const C0070 = () => {
  const paths: ITopicPath[] = [
    { title: 'キンクラコラムTOP', link: useRouteParam('/column') },
    { title: 'コラム記事一覧', link: useRouteParam('/column/list') },
    {
      title:
        'Excel(エクセル)でできる勤怠管理の限界とシステム導入で得られるメリットとは？',
    },
  ]

  // 0~8ランダム数字を保存
  const [no, setNo] = useState(-1)
  useEffect(() => {
    setNo(Math.floor(Math.random() * 9))
  }, [])

  return (
    <ColumnLayout paths={paths}>
      <SEO
        title="Excel(エクセル)でできる勤怠管理の限界とシステム導入で得られるメリットとは？"
        description="Excelは初期投資なしで勤怠管理を始められますが、一定規模を超えるとその限界が見えてきます。一方、勤怠管理システム「キンクラ」を導入することで、業務効率化、コスト削減、リスク管理、データの正確性と分析の向上が期待できるでしょう。本記事では勤怠管理システム「キンクラ」の導入メリットについても詳しく解説します。"
        ogUrl="https://kintaicloud.jp/column/details/C0070/"
        ogType="article"
        ogTitle="Excel(エクセル)でできる勤怠管理の限界とシステム導入で得られるメリットとは？"
        ogDescription="Excelは初期投資なしで勤怠管理を始められますが、一定規模を超えるとその限界が見えてきます。一方、勤怠管理システム「キンクラ」を導入することで、業務効率化、コスト削減、リスク管理、データの正確性と分析の向上が期待できるでしょう。本記事では勤怠管理システム「キンクラ」の導入メリットについても詳しく解説します。"
        ogSiteName="キンクラ - 客先常駐特化型のクラウド勤怠管理システム"
        ogImage="https://www.kintaicloud.jp/images/column/details/c0070.jpg"
      />
      <ColumnDetailsBody>
        {/** ポップアップバナー */}
        <PopupBanner />
        {/** 記事本体 */}
        <ColumnDetailInner0070 no={no} />

        {/** ここに9パターンの広告設定する */}
        {no === 0 && <Conclusion001 />}
        {no === 1 && <Conclusion002 />}
        {no === 2 && <Conclusion003 />}
        {no === 3 && <Conclusion004 />}
        {no === 4 && <Conclusion005 />}
        {no === 5 && <Conclusion006 />}
        {no === 6 && <Conclusion007 />}
        {no === 7 && <Conclusion008 />}
        {no === 8 && <Conclusion009 />}

        {/** オーサ情報 */}
        <ColumnAuthor004 />
        {/** お役立ち機能 */}
        <UsefulFunctionLayout003 />
        {/** 前後記事への遷移 */}
        <ColumnBackAndForth />
        {/** カルーセルバナー */}
        <CarouselBanner />
        {/** 関連記事 */}
        {/* <ColumnRelationCards0070 /> */}
      </ColumnDetailsBody>
    </ColumnLayout>
  )
}

export default C0070

export const pageQuery = graphql`
  query C0070 {
    site {
      siteMetadata {
        title
      }
    }
  }
`
